import '.c8{position:relative;}.ssr-plugin'
import '.i8{width:64px;}.ssr-plugin'
import '.i9{height:64px;}.ssr-plugin'
import '.bu{flex-shrink:0;}.ssr-plugin'
import '.az{position:absolute;}.ssr-plugin'
import '.ia{bottom:-4px;}.ssr-plugin'
import '.h6{right:-4px;}.ssr-plugin'
import '.ed{border-radius:50%;}.ssr-plugin'
import '.ib{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ai{overflow:hidden;}.ssr-plugin'
import '.ic{width:32px;}.ssr-plugin'
import '.id{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="c8 i8 i9 bu"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="az ia h6 ed ib ai ic id"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
